module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        // require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {

        const header = document.querySelector('header');
        const sticky = document.querySelector('.is-sticky');

        if (!header || !sticky) {
            return;
        }

        const body = document.body;
        let ticking = false;

        const update = function () {
            ticking = false;

            // Measure the sticky bar itself - it keeps its height when fixed, unlike the header
            const height = sticky.offsetHeight;
            const y = window.pageYOffset;
            const stuck = y > height;

            body.classList.toggle('stuck', stuck);
            body.classList.toggle('before-stuck', !stuck && y >= height / 2);

            // Only reserve space when the header sits in the page flow (e.g. body.relative).
            // By default it's absolutely positioned over the hero, so padding would push the page down.
            const inFlow = getComputedStyle(header).position !== 'absolute';
            body.style.paddingTop = stuck && inFlow ? height + 'px' : '';
        };

        const requestUpdate = function () {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
            }
        };

        window.addEventListener('scroll', requestUpdate, {passive: true});
        window.addEventListener('resize', requestUpdate);

        update();
    };


    module.navDropdownHover = function () {
        const triggers = document.querySelectorAll("[data-parent-id]");
        const children = document.querySelectorAll("[data-child-id]");
        let closeTimeout = null;

        function closeAll() {
            document.querySelectorAll('.line.active').forEach(el => el.classList.remove("active"));
            triggers.forEach(p => p.classList.remove("active"));
            children.forEach(c => c.classList.remove("active"));
        }

        function openMenu(id) {
            if (closeTimeout) clearTimeout(closeTimeout);
            closeAll();

            const wrapper = document.getElementById(`wrapper-${id}`);
            if (wrapper) {
                wrapper.classList.add("active");
            } else {
                const fallback = document.querySelector(`[data-parent-id="${id}"]`);
                if (fallback) fallback.classList.add("active");
            }

            const child = document.querySelector(`[data-child-id="${id}"]`);
            if (child) child.classList.add("active");
        }

        function scheduleClose() {
            closeTimeout = setTimeout(() => {
                closeAll();
            }, 200);
        }

        triggers.forEach(trigger => {
            const id = trigger.dataset.parentId;
            trigger.addEventListener("mouseenter", () => openMenu(id));
            trigger.addEventListener("mouseleave", scheduleClose);
        });

        children.forEach(child => {
            const id = child.dataset.childId;
            child.addEventListener("mouseenter", () => openMenu(id));
            child.addEventListener("mouseleave", scheduleClose);
        });
    };

    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'linear',
            fade: true,
            prevArrow: $('.testi-prev'),
            nextArrow: $('.testi-next'),
        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
        });

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 9000,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            waitForAnimate: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick-carousel.news').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 9000,
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false,
            waitForAnimate: false,
            prevArrow: $('.article-prev'),
            nextArrow: $('.article-next'),


            responsive: [
                {
                    breakpoint: 2000,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 820,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        var $carousel = $('.slick.cards-carousel');

        $carousel.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '150px',
            draggable: true,
            arrows: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 9000,
            cssEase: 'linear',
            waitForAnimate: false,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },
            ]
        });

        // Set fast speed BEFORE slick handles the click
        // (mousedown/touchstart fire before the click event)
        $carousel.on('mousedown touchstart', '.slick-arrow, .slick-dots li', function () {
            $carousel.slick('slickSetOption', 'speed', 400);
            $carousel.slick('slickSetOption', 'cssEase', 'ease');
        });

        // Restore the slow continuous scroll after the manual transition finishes
        // just longer than the 400ms click transition
        $carousel.on('afterChange', function () {
            setTimeout(function () {
                $carousel.slick('slickSetOption', 'speed', 9000);
                $carousel.slick('slickSetOption', 'cssEase', 'linear');
            }, 450);
        });


        $('.slick-carousel.projects-gallery').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            //variableWidth: false,
            //adaptiveHeight: false,
            arrows: true,
            dots: false,
            prevArrow: $('.image-prev'),
            nextArrow: $('.image-next'),

            responsive: [

                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '10px'
                    }
                }
            ],

        });

        $('.slick.news-gallery').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });


    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };


    module.statCounter = function () {
        const counters = document.querySelectorAll('.count-up');

        const animateCount = (counter) => {
            const raw = counter.getAttribute('data-count');

            // Extract the parts:
            // 1. Prefix (anything before the number)
            // 2. Number (the actual digits/decimals)
            // 3. Suffix (anything after the number)
            const match = raw.match(/^([^0-9.-]*)([0-9.-]+)(.*)$/);

            if (!match) return; // Exit if format is weird

            const prefix = match[1];
            const target = parseFloat(match[2]);
            const suffix = match[3];

            const duration = 3000;
            const frameRate = 60;
            const totalFrames = Math.round(duration / (1000 / frameRate));
            let frame = 0;

            const count = () => {
                frame++;
                // Simple linear easing: (currentFrame / totalFrames)
                const progress = frame / totalFrames;
                const value = Math.round(target * progress);

                // Reconstruct the string with the prefix and suffix
                counter.textContent = `${prefix}${value}${suffix}`;

                if (frame < totalFrames) {
                    requestAnimationFrame(count);
                } else {
                    // Ensure we land exactly on the target value at the end
                    counter.textContent = raw;
                }
            };

            count();
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateCount(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {threshold: 0.6});

        counters.forEach(counter => observer.observe(counter));
    };


    return module;

};
